import { actionTypes } from '../actions/cookies';
import cookieUtil from 'tradera-utils/cookie';
import { MYTRADERA_DEFAULT_COOKIES } from 'tradera-constants/cookies';
import { logger } from 'packages';

const defaultState = () => {
    let defaultCookies = {};
    Object.keys(MYTRADERA_DEFAULT_COOKIES).forEach(value => {
        let val = cookieUtil.readCookie(MYTRADERA_DEFAULT_COOKIES[value].key);
        defaultCookies[value] = val
            ? val
            : MYTRADERA_DEFAULT_COOKIES[value].default;
    });
    return defaultCookies;
};

export default (state = defaultState(), action) => {
    const set = () => {
        let def = MYTRADERA_DEFAULT_COOKIES[action.payload.name];
        const expires = def.length;
        try {
            cookieUtil.createCookie(def.key, action.payload.value, expires);
        } catch (e) {
            logger(e);
        }
        if (state[action.payload.name] === action.payload.value) {
            return state;
        }
        return {
            ...state,
            [action.payload.name]: action.payload.value
        };
    };

    const def = () => state;

    const reducers = {
        [actionTypes.SET]: set
    };
    return !reducers[action.type] ? def() : reducers[action.type]();
};

export const selectCookiesState = state => state.views.myTradera.cookies;
